import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Table from "@insite/mobius/Icons/Table";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setPurchaseHistoryView from "@NA/Handlers/PurchaseHistory/SetPurchaseHistoryView";
import GridIcon from "@NA/Icons/GridIcon";
import ListIcon from "@NA/Icons/ListIcon";
import { MyPurchaseHistoryListViewType } from "@NA/Services/GetMyPurchaseHistory";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomApplicationState) => ({
    products: state.ADIGlobalData.myPurchaseHistoryStore.myPurchaseHistory?.products,
    view: state.ADIGlobalData.myPurchaseHistoryStore.view,
});

const mapDispatchToProps = {
    setPurchaseHistoryView,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PurchaseHistoryViewSelectStyles {
    wrapper?: InjectableCss;
    listViewClickable?: ClickablePresentationProps;
    listViewIcon?: IconPresentationProps;
    gridViewClickable?: ClickablePresentationProps;
    gridViewIcon?: IconPresentationProps;
    tableViewClickable?: ClickablePresentationProps;
    tableViewIcon?: IconPresentationProps;
    listSelected?: InjectableCss;
}

export const purchaseHistoryViewSelectStyles: PurchaseHistoryViewSelectStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: center;
            border-radius: 7px;
            border: solid 1px #bbb;
            margin-top: 5px;
            background-color: #d7d9db;
            button {
                height: 37px;
                padding: 12px;
                background-color: transparent;
                outline: 0 !important;
                svg path {
                    fill: ${getColor("text.main")};
                }
            }

            .viewSelected {
                outline: 0 !important;
                background-color: ${getColor("common.background")};
                border-radius: 7px;
                border: solid 1px #bbb;
                svg path {
                    fill: ${getColor("primary")};
                }
            }
        `,
    },
    listViewIcon: {
        src: ListIcon,
        size: 20,
    },
    gridViewIcon: {
        src: GridIcon,
        size: 20,
    },
    tableViewIcon: {
        src: Table,
        size: 26,
    },
};

const styles = purchaseHistoryViewSelectStyles;

class PurchaseHistoryViewSelect extends React.Component<Props> {

    render() {
        const { products, view, setPurchaseHistoryView } = this.props;

        if (!products || products.length < 1) {
            return null;
        }

        const clickListViewHandler = () => {
            changeView("List");
        };

        const clickGridViewHandler = () => {
            changeView("Grid");
        };

        const changeView = (view: MyPurchaseHistoryListViewType) => {
            setPurchaseHistoryView({ view });
        };

        return (
            <StyledWrapper {...styles.wrapper}>
                <Clickable
                    data-test-selector="viewSelectGrid"
                    {...styles.gridViewClickable}
                    onClick={clickGridViewHandler}
                    className={view === "Grid" ? "viewSelected" : "viewNormal"} title="Grid"
                >
                    <Icon {...styles.gridViewIcon} color={view === "Grid" ? "primary" : undefined} />
                </Clickable>
                <Clickable
                    data-test-selector="viewSelectList"
                    {...styles.listViewClickable}
                    onClick={clickListViewHandler}
                    className={view === "List" ? "viewSelected" : "viewNormal"} title="List"
                >
                    <Icon {...styles.listViewIcon} color={view === "List" ? "primary" : undefined} />
                </Clickable>
            </StyledWrapper>
        );
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseHistoryViewSelect);
